import React, { useEffect, useState } from "react";
import Text from "antd/lib/typography/Text";
import { Button, Image, Progress } from "antd";
import StackedBarChart from "../../components/StackedBar";
import styles from "../../styles/dashboard.module.scss";
import moment from "moment";
import { authSVC } from "../../services";
import { useB2BContext } from "../../context/ContextB2B";

function BarChartOverview() {
  const [tapIndex3, setTapIndex3] = useState<number>(0);
  const { getUserByID } = useB2BContext();
  const [yearlyIndexesData, setYearlyIndexesData] = useState<any>();

  useEffect(() => {
    if (getUserByID) {
      authSVC
        .YearlyIndexesData({ company: getUserByID?.company })
        .then((res) => {
          console.log(res?.data?.data.series.length, "03");
          setYearlyIndexesData(res?.data?.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getUserByID]);

  return (
    <div className={styles.white_bg_wrapper}>
      <div className={styles.info_title}>
        <div className={styles.title_grp}>
          <Text
            style={{
              color: tapIndex3 === 0 ? "" : "#2E3191",
              opacity: tapIndex3 === 0 ? "" : "0.3",
            }}
            className={styles.title}
            onClick={() => setTapIndex3(0)}
          >
            Month-on-Month Team Wellbeing
          </Text>
           <div className="leaf_align">
                          <img src="/figma/leaf.svg" alt=""  width={16}
                          height={16}/>
                          <div className="value">
                            <Text className="lower_h">Lower score</Text>
                            <Text className="lower_p">means a calmer mind</Text>
                          </div>
                        </div>
        </div>
        <div className={styles.title_grp1}>
          <Image
            className={styles.img}
            src="/figma/up_arrow.svg"
            preview={false}
          />
          <Text className={`${styles.subtitle1} up_arrow_font`}>
            {yearlyIndexesData?.percentage || 0}% from last month
          </Text>
        </div>
      </div>

      <div className={styles.title_grp1}></div>
      <div className={styles.graph}>
        {yearlyIndexesData?.series?.[0].data.length === 0 ? (
          <div className="no_data_yet">
            <img src="/img/User_empty.png" alt="" width="56" height="52" />
            <p>No data yet</p>
          </div>
        ) : (
          <StackedBarChart chartData={yearlyIndexesData} />
        )}
      </div>
    </div>
  );
}

export default BarChartOverview;
